<template>
  <div class="bidding-activities">
    <second-menu-link-content>
      <template v-slot:header>
        <span>活动竞价</span>
      </template>
      <template v-slot:content>
        <div class="bidding-activities-main">
          <div
            class="add-promotion"
            v-if="operationList.indexOf(operationsBtns.roleSaleActivityManage)!==-1"
          >
            <el-button class="btn-blue" @click="addActivities">新增活动</el-button>
          </div>
          <div class="search">
            <span>竞价状态：</span>
            <el-select
              class="white"
              clearable
              placeholder="请选择竞价状态"
              v-model="biddingStatus"
            >
              <el-option
                v-for="(item, index) in biddingStatusList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <span class="activityStatus">活动状态：</span>
            <el-select
              class="white"
              clearable
              placeholder="请选择活动状态"
              v-model="activityStatus"
            >
              <el-option
                v-for="(item, index) in activityStatusList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button class="btn-blue" @click="searchBiddingStatusList">搜索</el-button>
          </div>
          <div class="table-img">
            <el-table :data="tableData" style="width: 100%" v-loading="loading">
              <el-table-column prop="activityName" label="活动名称">
                <template slot-scope="scope">
                  <p class="name">{{scope.row.activityName}}</p>
                </template>
              </el-table-column>
              <el-table-column label="竞价时间" min-width="184px">
                <template slot-scope="scope">
                  <p>{{scope.row.biddingBeginTime}}至<br>{{scope.row.biddingEndTime}}</p>
                </template>
              </el-table-column>
              <el-table-column label="活动时间" min-width="184px">
                <template slot-scope="scope">
                  <p>{{scope.row.beginTime}}至<br>{{scope.row.endTime}}</p>
                </template>
              </el-table-column>
              <el-table-column prop="statusValue" label="状态"></el-table-column>
              <el-table-column label="操作" width="140">
                <template slot-scope="scope">
                  <el-button
                    class="btn-text"
                    type="text"
                    @click="toBiddingDetailsDetailById(scope.row)"
                  >查看</el-button>
                  <el-button
                    v-if="operationList.indexOf(operationsBtns.roleSaleActivityManage)!==-1&&scope.row.activityStatus == 6"
                    class="btn-text"
                    type="text"
                    @click="deleteBiddingDetailsDetail(scope.row.id)"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-tpl-container">
              <pagination-tpl
                :total="totalNum"
                :currentPage="currentPage"
                @queryChange="onQueryChange"
              ></pagination-tpl>
            </div>
          </div>
        </div>
      </template>
    </second-menu-link-content>
    <el-dialog
      title="新增活动"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="30%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="活动名称：" prop="activityName">
          <el-input v-model="ruleForm.activityName" placeholder="请输入活动名称"></el-input>
        </el-form-item>
        <el-form-item label="竞价时间：" required>
          <el-col :span="11">
            <el-form-item prop="biddingBeginTime">
              <el-date-picker type="datetime" placeholder="请选择时间" :picker-options="pickerOptions" v-model="ruleForm.biddingBeginTime" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2">至</el-col>
          <el-col :span="11">
            <el-form-item prop="biddingEndTime">
              <el-date-picker type="datetime" placeholder="请选择时间" :picker-options="pickerOptions" v-model="ruleForm.biddingEndTime" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="活动时间：" required>
          <el-col :span="11">
            <el-form-item prop="beginTime">
              <el-date-picker type="datetime" placeholder="请选择时间" :picker-options="pickerOptions" v-model="ruleForm.beginTime" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2">至</el-col>
          <el-col :span="11">
            <el-form-item prop="endTime">
              <el-date-picker type="datetime" placeholder="请选择时间" :picker-options="pickerOptions" v-model="ruleForm.endTime" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="展位数量：" prop="boothNum">
          <el-input v-model="ruleForm.boothNum" placeholder="请输入展位数"></el-input>
        </el-form-item>
        <el-form-item label="起拍价格：" prop="basePrice">
          <el-input v-model="ruleForm.basePrice" placeholder="请输入起拍价格"></el-input>
        </el-form-item>
        <el-form-item label="活动规则：" prop="promotionType">
          <el-radio-group v-model="ruleForm.promotionType">
            <el-radio :label="1">商品直降</el-radio>
            <el-radio :label="2">活动满减</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="指定仓库：" prop="selectedWarehouseTags">
          <el-select
            v-model="ruleForm.selectedWarehouseTags"
            multiple
            placeholder="请选择指定仓库"
          >
            <el-option
              v-for="(item, index) in warehouseTagList"
              :key="index"
              :value="item.id"
              :label="item.name"
              :disabled="item.id === warehouseTagList[0].id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { setActivityInfo, getDBOperationPermission } from 'common/js/storage';
import { formaTimeToSecond } from "common/js/util.js";
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationTpl from "base/PaginationTpl";
import DBBiddingActivities from "models/db/biddingActivities.js";
import DBInventory from "models/db/inventory.js";
const dbInventory = new DBInventory();
const dbBiddingActivities = new DBBiddingActivities();
export default {
  components: {
    SecondMenuLinkContent,
    PaginationTpl
  },
  data() {
    // 此处自定义校验展位数
    var validateNum = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入展位数'))
      }
      if (Number.isInteger(Number(value))&&value>0&&value<=50) {
        callback()
      } else {
        callback(new Error('展位数必须为正整数，并不大于50'))
      }
    }
    // 此处自定义校验起拍价格
    var validateBasePrice = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入起拍价格'))
      }
      if (Number.isInteger(Number(value))) {
        if (value>0) {
          callback()
        } else {
          callback(new Error('起拍价格必须大于0'))
        }
      } else {
        callback(new Error('起拍价格必须为整数'))
      }
    }
    return {
      // 页面按钮权限--新增、删除
      operationsBtns: {
        roleSaleActivityManage: "ROLE_SALE_activity_manage"
      },
      biddingStatusList: [
        { label: '待竞价', value: 1},
        { label: '竞价中', value: 2},
        { label: '待发布', value: 3},
        { label: '已发布', value: 4},
      ],
      activityStatusList: [
        { label: '活动中', value: 5},
        { label: '已结束', value: 6},
      ],
      biddingStatus: "",
      activityStatus: "",
      tableData: [],
      totalNum: 0,
      currentPage: 1,
      loading: true,
      dialogVisible: false,
      warehouseTagList: [], // 指定仓库列表
      ruleForm: {
        activityName: '',
        biddingBeginTime: '',
        biddingEndTime: '',
        beginTime: '',
        endTime: '',
        boothNum: '',
        basePrice: '',
        promotionType: 1,
        selectedWarehouseTags: []
      },
      rules: {
        activityName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
        ],
        biddingBeginTime: [
          {required: true, message: '请选择时间', trigger: 'change' }
        ],
        biddingEndTime: [
          {required: true, message: '请选择时间', trigger: 'change' }
        ],
        beginTime: [
          {required: true, message: '请选择时间', trigger: 'change' }
        ],
        endTime: [
          {required: true, message: '请选择时间', trigger: 'change' }
        ],
        boothNum: [
          { required: true, validator: validateNum, trigger: 'blur' },
        ],
        basePrice: [
          { required: true, validator: validateBasePrice, trigger: 'blur' },
        ],
        promotionType: [
          { required: true, message: '请选择活动规则', trigger: 'change' }
        ],
      },
      //设置当前时间前不可选
      pickerOptions: {
        //限制时间
        // selectableRange: this.selectableRange(),
        // 限制日期
        disabledDate: this.disabledDate
      },
    };
  },
  created() {
    this.operationList = getDBOperationPermission();
    this.getBiddingActivitiesList();
    this.initWarehouseTagList();
  },
  methods: {
    addActivities() {
      this.ruleForm.activityName= ''
      this.ruleForm.biddingBeginTime= ''
      this.ruleForm.biddingEndTime= ''
      this.ruleForm.beginTime= ''
      this.ruleForm.endTime= ''
      this.ruleForm.boothNum= ''
      this.ruleForm.basePrice= ''
      this.ruleForm.selectedWarehouseTags = [this.warehouseTagList[0].id]
      this.dialogVisible = true
    },
    selectableRange() {
      let date = new Date()
      let hour = date.getHours()
      hour = hour > 9 ? hour : '0' + hour
      let minute = date.getMinutes()
      minute = minute > 9 ? minute : '0' + minute
      let second = date.getSeconds()
      second = second > 9 ? second : '0' + second
      let time = `${hour}:${minute}:${second}`
      console.log(time);
      console.log(date.toLocaleDateString());
      const selectableRange = `${time}-23:59:59`
      return selectableRange
    },
    disabledDate(date) {
      //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
      return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
    },
    // 获取活动竞价列表
    getBiddingActivitiesList() {
      let biddingStatus = this.biddingStatus;
      let activityStatus = this.activityStatus;
      let currentPage = this.currentPage;
      dbBiddingActivities.getDBActivityList(biddingStatus, activityStatus, currentPage).then(res => {
        if (res.success) {
          this.totalNum = res.result.totalNum;
          let arr = [];
          res.result.items.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.activityName = value.activityName;
            obj.beginTime = formaTimeToSecond(value.beginTime);
            obj.endTime = formaTimeToSecond(value.endTime);
            obj.biddingBeginTime = formaTimeToSecond(value.biddingBeginTime);
            obj.biddingEndTime = formaTimeToSecond(value.biddingEndTime);
            obj.biddingStatus = value.biddingStatus;
            obj.activityStatus = value.activityStatus;
            obj.boothNum = value.boothNum;
            obj.basePrice = value.basePrice;
            let statusValue = ''
            if (value.biddingStatus > 0) {
              this.biddingStatusList.map(i => {
                if (i.value == value.biddingStatus) {
                  statusValue = i.label
                }
              })
            }
            if (value.activityStatus > 0) {
              this.activityStatusList.map(i => {
                if (i.value == value.activityStatus) {
                  if (statusValue) {
                    statusValue = `${statusValue}/${i.label}`
                  } else {
                    statusValue = `${i.label}`
                  }
                }
              })
            }
            obj.statusValue = statusValue
            arr.push(obj);
          });
          this.tableData = arr;
          this.loading = false;
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      });
    },
    // 搜索
    searchBiddingStatusList() {
      this.currentPage = 1;
      this.getBiddingActivitiesList();
    },
    // 点击删除
    deleteBiddingDetailsDetail(id) {
      this.$confirm("是否确定删除当前活动?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: 'bidding-messageBox',
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-white',
      })
        .then(() => {
          let data = { id };
          dbBiddingActivities.getDBActivityDelete(data).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '活动删除成功'
              });
              this.getBiddingActivitiesList();
            } else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          });
        })
    },
    // 点击查看详情
    toBiddingDetailsDetailById(row) {
      this.$router.push({
        path: "/admin/marketing/bidding-activities/biddingDetails",
        query: {
          id: row.id
        }
      });
    },
    // 翻页
    onQueryChange(data) {
      this.currentPage = data.currentPage;
      this.getBiddingActivitiesList();
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formaTimeToSecond(this.ruleForm.biddingBeginTime) >= formaTimeToSecond(this.ruleForm.biddingEndTime)) {
            this.$message({
              type: 'error',
              message: '竞价结束时间必须大于竞价开始时间'
            });
            return
          }
          if (formaTimeToSecond(this.ruleForm.beginTime) <= formaTimeToSecond(this.ruleForm.biddingEndTime)) {
            this.$message({
              type: 'error',
              message: '活动开始时间必须大于竞价结束时间'
            });
            return
          }
          if (formaTimeToSecond(this.ruleForm.beginTime) >= formaTimeToSecond(this.ruleForm.endTime)) {
            this.$message({
              type: 'error',
              message: '活动开始时间必须小于活动结束时间'
            });
            return
          }
          let data = {}
          data.activityName = this.ruleForm.activityName
          data.biddingBeginTime = formaTimeToSecond(this.ruleForm.biddingBeginTime)
          data.biddingEndTime = formaTimeToSecond(this.ruleForm.biddingEndTime)
          data.beginTime = formaTimeToSecond(this.ruleForm.beginTime)
          data.endTime = formaTimeToSecond(this.ruleForm.endTime)
          data.boothNum = Number(this.ruleForm.boothNum)
          data.basePrice = this.ruleForm.basePrice
          data.promotionType = Number(this.ruleForm.promotionType)
          data.warehouseIdList = this.ruleForm.selectedWarehouseTags
          dbBiddingActivities.getDBActivityAdd(data).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '活动新增成功'
              });
              this.getBiddingActivitiesList();
              this.dialogVisible = false
            } else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /* 获取指定仓库列表 */
    initWarehouseTagList() {
      dbInventory.getDBAllWarehouse().then(res => {
        if (res.success) {
          let d = [
            { id: 1, name: '系统仓'},
            { id: 2, name: '杭州仓'},
            { id: 3, name: '宁波仓'},
            { id: 4, name: '温州仓'},
            { id: 5, name: '台州仓'},
            { id: 6, name: '丽水仓'},
            { id: 7, name: '金华仓'},
            { id: 8, name: '义乌仓'},
            { id: 9, name: '嵊州仓'},
            { id: 10, name: '衢州仓'},
            { id: 11, name: '天台仓'},
          ]
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.name = i.name
            arr.push(obj)
          })
          this.warehouseTagList = arr
          this.selectedWarehouseTags = [arr[0].id]
        } else {
          this.$message.error(res.message)
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.bidding-activities {
  width: 100%;
  height: 100%;
  .bidding-activities-main {
    .add-promotion {
      margin-bottom: 16px;
    }
    .search {
      padding: 16px;
      background: rgba(245, 247, 250, 1);
      border-radius: 4px;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .el-input {
        width: 320px;
      }
      .el-button {
        margin-left: 16px;
      }
      span {
        font-size: 14px;
      }
      .activityStatus {
        margin-left: 10px;
      }
    }
    .table-img {
      .pagination-tpl-container {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}
</style>
<style lang="scss">
.bidding-activities {
  .el-dialog {
    margin-top: 24vh!important;
    .el-dialog__header {
      border-bottom: 1px solid #EEE;
      .el-dialog__title {
        font-size: 16px;
        font-weight: bold;
        color: #666666;
        line-height: 24px;
      }
    }
    .el-dialog__footer {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 72px;
      border-top: 1px solid #EEE;
    }
    .el-dialog__body {
      padding-bottom: 0px;
      .el-form {
        padding: 20px 0px;
        .el-form-item__content {
          .el-input,
          .el-input__inner {
            height: 32px;
            background: rgba(245, 247, 250, 0.2);
          }
          .line {
            text-align: center;
          }
        }
        .el-form-item {
          height: 32px;
          margin-bottom: 16px;
        }
        .el-select {
          width: 100%;
          height: 100%;
        }
        .el-form-item:nth-last-child(1) {
          height: auto;
          .el-form-item__content {
            height: 100%;
          }
          .el-input--suffix {
            height: 100%;
          }
        }
        .el-select__tags {
          > span {
            span:nth-child(1) {
              .el-tag__close {
                display: none;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style>
.bidding-messageBox .el-message-box__header {
    border-bottom: 1px solid #eee;
    padding-bottom: 15px;
  }
</style>